import autoBind from 'react-autobind/src/autoBind';
import TableHelper from 'src/utils/table-helper';
import React, { Component } from 'react';
import moment from 'moment';
import { asyncRequest, Entities, TOMCAT_URL } from 'src/common';
import { FilterToggle } from 'src/components/admin/buslocations/filter-toggle';
import DatePicker from 'material-ui/DatePicker';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { withTranslation } from 'react-i18next';
import ErrorMessage from 'src/components/misc/error-message';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { validFormatter } from 'src/utils/formatters';

class AdminBusRequestsOverviewAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.tableHelper = new TableHelper();
        this.state = {
            startedFetching: false,
            fromDate: moment().startOf('month').toDate(),
            toDate: moment().toDate(),
            filterIntegrations: [],
            selectedFilterIntegration: '',
            noDate: false,
        };
    }

    componentWillMount() {
        this.fetchBusRequests();
    }

    createActiveFilterForQuery() {
        const queryParams = [];
        if (this.state.fromDate && this.state.toDate) {
            queryParams.push(`fromDate=${moment(this.state.fromDate).format('YYYY-MM-DD')}`);
            queryParams.push(`toDate=${moment(this.state.toDate).format('YYYY-MM-DD')}`);
        }

        queryParams.push(`bookingIntegrationId=${this.state.selectedFilterIntegration}`);
        queryParams.push(`salesIntegration=${this.state.salesIntegration}`);

        return queryParams.join('&');
    }

    fetchBusRequests = () => {
        this.props.search(
            Entities.BUS_REQUESTS,
            `statistics?${this.createActiveFilterForQuery()}`,
            0,
            undefined,
            true,
            () => {
                this.setState({ startedFetching: false });
            },
        );
    };

    toggleDate = val => {
        this.setState({ noDate: !this.state.noDate });

        if (this.state.noDate) {
            this.setState({ fromDate: moment().startOf('month').toDate(), toDate: moment().toDate() });
        } else {
            this.setState({ fromDate: undefined, toDate: undefined });
        }
    };

    createCustomToolbar() {
        const { t, busRequests } = this.props;
        const { isFetching } = this.props.busRequests;
        const menuItems = new Map();
        if (!busRequests.isFetching && busRequests.items.length > 0) {
            busRequests.items.forEach(item => {
                menuItems.set(item.bookingIntegration.id, item.bookingIntegration);
            });
        }

        return (
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-12" style={{ display: 'flex', gap: 20, alignItems: 'flex-end' }}>
                        <div>
                            <FilterToggle
                                label={t('find_my_bus.total_timespan')}
                                labelStyle={{
                                    width: '250px',
                                    fontSize: '10px',
                                }}
                                toggled={this.state.noDate}
                                onToggle={() => this.toggleDate(!this.state.noDate)}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                    <div>
                        <DatePicker
                            value={this.state.fromDate}
                            container="inline"
                            disabled={isFetching || this.state.noDate}
                            formatDate={date => moment(date).format('DD.MM.YYYY')}
                            floatingLabelText={t('search_requests.from.title')}
                            onChange={(_event, value) => this.setState({ fromDate: value })}
                            maxDate={this.state.toDate}
                            autoOk={true}
                            textFieldStyle={{ width: 130, marginLeft: 7 }}
                        />
                    </div>
                    <div>
                        <DatePicker
                            value={this.state.toDate}
                            container="inline"
                            disabled={isFetching || this.state.noDate}
                            formatDate={date => moment(date).format('DD.MM.YYYY')}
                            floatingLabelText={t('search_requests.to.title')}
                            onChange={(_event, value) => this.setState({ toDate: value })}
                            minDate={this.state.fromDate}
                            autoOk={true}
                            textFieldStyle={{ width: 130, marginLeft: 30 }}
                        />
                    </div>

                    <div className="col-md-3">
                        {this.state.filterIntegrations && (
                            <SelectField
                                value={this.state.selectedFilterIntegration}
                                onChange={(event, index, value) => {
                                    this.setState({
                                        selectedFilterIntegration: value,
                                    });
                                }}
                                floatingLabelText={t('find_my_bus.choose_booking_integration')}
                                fullWidth={true}
                                floatingLabelFixed={true}>
                                <MenuItem value={null} primaryText={t('common_phrases.all')} />
                                {Array.from(menuItems.values()).map(item => (
                                    <MenuItem key={item.id} value={item.id} primaryText={item.name} />
                                ))}
                            </SelectField>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.tableHelper.processPaginationAfterUpdate(prevProps.busRequests, this.props.busRequests, this.table))
            this.setState({ renderSelection: !this.state.renderSelection });

        if (
            prevState.fromDate !== this.state.fromDate ||
            prevState.toDate !== this.state.toDate ||
            prevState.selectedFilterIntegration !== this.state.selectedFilterIntegration ||
            prevState.noDate !== this.state.noDate
        ) {
            this.fetchBusRequests();
        }
    }

    render() {
        const { t, busRequests } = this.props;
        const tableData = [];

        const finishFetching = !this.state.startedFetching && !busRequests.isFetching;
        if (busRequests.error) return <ErrorMessage object={busRequests} />;
        if (!busRequests.isFetching && busRequests.items.length > 0) {
            busRequests.items.map(request => {
                tableData.push({
                    id: request.id,
                    createdAt: moment(request.createdAt).utc().format('DD.MM.YYYY HH:mm:ss'),
                    bookingIntegrationName: request.bookingIntegration.name,
                    email: request.customerContactData != null ? request.customerContactData.email : null,
                    from: request.from.location.address,
                    fromTime: moment(request.from.time).format('DD.MM.YYYY HH:mm'),
                    to: request.to.location.address,
                    pax: request.pax,
                    returnTrip: request.returnTrip,
                    booking: request.booking,
                    isOffer: request.booking != null && request.booking.offerDetails.offerStatus === 'OPEN',
                    isBooked: request.booking != null && request.booking.offerDetails.offerStatus === 'ACCEPTED',
                    entity: request,
                });
            });
        }

        return (
            <>
                {this.createCustomToolbar()}

                <div>
                    <BootstrapTableErrorBoundary>
                        <BootstrapTable
                            ref={ref => (this.table = ref)}
                            data={tableData}
                            striped={true}
                            hover={true}
                            exportCSV={true}
                            condensed={true}
                            pagination={true}
                            options={Object.assign(
                                { toolBar: this.createCustomToolBar },
                                this.tableHelper.getOptions(finishFetching),
                            )}
                            selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                            searchPlaceholder={t('common_phrases.search')}
                            search={true}>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="id"
                                hidden={true}
                                isKey={true}
                                export={true}>
                                ID
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="80" dataField="createdAt" dataSort={true}>
                                {t('find_my_bus.requested')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                width="50"
                                dataField="bookingIntegrationName"
                                dataSort={true}>
                                {t('find_my_bus.bookingIntegration')}
                            </TableHeaderColumn>
                            <TableHeaderColumn width="100" dataField="email" dataSort={true}>
                                {t('search_requests.email')}
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="80" dataField="fromTime" dataSort={true}>
                                {t('search_requests.from.time')}
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="140" dataField="from" dataSort={true}>
                                {t('search_requests.from.location')}
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="140" dataField="to" dataSort={true}>
                                {t('search_requests.to.location')}
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="40" dataField="pax" dataSort={true}>
                                {t('search_requests.pax')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                width="50"
                                dataField="isOffer"
                                dataSort={true}
                                dataFormat={cell => validFormatter(t, cell === true)}>
                                {t('bus_requests.statistics.offer_created')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                width="50"
                                dataField="isBooked"
                                dataSort={true}
                                dataFormat={cell => validFormatter(t, cell === true)}>
                                {t('bus_requests.statistics.customer_booked')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="actions"
                                width="60"
                                dataFormat={this.tableActionsFormatter}
                                export={false}>
                                {t('common_phrases.actions')}
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </BootstrapTableErrorBoundary>
                </div>
            </>
        );
    }

    tableActionsFormatter = (_cell, request) => {
        const { t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title={t('user_functionality.open_in_route_planner')}
                    onClick={() => {
                        asyncRequest(`${TOMCAT_URL}api/${Entities.BUS_REQUESTS.repository}/create-link/${request.id}`)
                            .then(response => {
                                const json = response.json;
                                if (json && json.url) {
                                    const win = window.open(json.url, '_blank');
                                    if (win != null) win.focus();
                                }
                            })
                            .catch(error => console.error('Error creating Link', error));
                    }}>
                    <span className="glyphicon glyphicon-info-sign text-info" />
                </button>
            </div>
        );
    };
}

export default composeModalActions(withTranslation()(AdminBusRequestsOverviewAdministration));
